export default "__VITE_ASSET__V_lY9cKi__"